import React from "react";
import VolunteerForm from "../../components/PagesForm/VolunteerForm";

const VolunteerAdd = () => {
  return <VolunteerForm isEdit={false} isAddVolunteer={true} />;
};

export default VolunteerAdd;
